var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#star_svg__a)",
    d: "M16.203 8.293c.153-1.16 1.83-1.16 1.983 0l.682 5.17a1 1 0 0 0 1.174.852l5.127-.949c1.15-.212 1.668 1.383.613 1.886L21.076 17.5a1 1 0 0 0-.448 1.379l2.487 4.584c.557 1.027-.8 2.013-1.604 1.165l-3.591-3.781a1 1 0 0 0-1.45 0l-3.591 3.781c-.805.848-2.162-.138-1.604-1.165l2.486-4.584a1 1 0 0 0-.448-1.38l-4.706-2.246c-1.055-.503-.537-2.098.613-1.886l5.128.95a1 1 0 0 0 1.173-.853z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "star_svg__a",
    x1: 17.195,
    x2: 17.195,
    y1: 0.78,
    y2: 33.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B93B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#FA8435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#FF6932"
  })))));
};
export default SvgStar;